import { render, staticRenderFns } from "./uploadTrainingMaterial.vue?vue&type=template&id=3cfc486f&scoped=true"
import script from "./uploadTrainingMaterial.vue?vue&type=script&lang=js"
export * from "./uploadTrainingMaterial.vue?vue&type=script&lang=js"
import style0 from "./uploadTrainingMaterial.vue?vue&type=style&index=0&id=3cfc486f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc486f",
  null
  
)

export default component.exports